import LenderPageTemplate from '@/components/shared/LenderPageTemplate'

const CloseBrothersFinancePage = () => {
  return (
    <LenderPageTemplate
      lenderName="Close Brothers"
      slug="/lenders/mis-sold-close-brothers-car-finance"
      seoImage=""
      seoImageAlt=""
      aiOverview=""
    />
  )
}

export default CloseBrothersFinancePage
